const angular = require('angular');
var app = angular.module('learn-controllers');

/**
 * Edit Articles Controller
 * @argument {Application} Application injected to gain access to the global Application functions and properties
 * @argument {Analyze} Analyze injected to gain access to the Analyze resource
 * @argument {Articles} Articles injected to gain access to the Articles resource
 */
app.controller('editArticle', ['Application', 'Authorization', 'Articles', 'Analyze', 'Viewables', 'AccessHelper', 'AdminContent', 'SurveyHelper', '$scope', '$translate', '$filter', 'FroalaOptions', function (Application, Authorization, Articles, Analyze, Viewables, AccessHelper, AdminContent, SurveyHelper, $scope, $translate, $filter, FroalaOptions) {
  var self = this;
  var routeParameters = Application.navigation.getRouteParameters();
  self.newArticle = routeParameters.id === 'new' || !routeParameters.id;
  self.features = Application.features.flags();
  self.allowance = {
    create_article: AccessHelper.isAllowed(['admin', 'content', 'all_create'], [['admin', 'content', 'articles_create']], ['admin', 'creator', 'collaborator']),
    edit_article: AccessHelper.isAllowed(['admin', 'content', 'all_edit'], [['admin', 'content', 'articles_edit'], ['admin', 'content', 'my_content_edit']], ['admin', 'creator', 'collaborator']),
    add_survey: self.features.surveys && AccessHelper.isAllowed(['admin', 'surveys'], null, ['admin']),
    add_partner: self.features.enable_partners && AccessHelper.isAllowed(['admin', 'content'], null, ['admin']),

  };

  if ((!self.newArticle && !self.allowance.edit_article) || (self.newArticle && !self.allowance.create_article)) {
    Application.navigation.goTo('/explore');
    return;
  }

  self.authtoken = Authorization.getAuthToken();
  self.user = self.authtoken.user;
  self.is_collaborator = Authorization.isCollaborator();
  self.autoDuration = true;
  self.editSaved = true;
  self.backLocation = Application.navigation.history[Application.navigation.history.length - 2];
  self.denied = false;
  self.archiveInfo = {};

  self.froalaLocalOptions = {
    width: 758,
    imageDefaultWidth: 600,
    toolbarStickyOffset: (window.innerWidth > 991 ? 153:133),
    toolbarButtons:   {
      moreText: {
        buttons: ['bold', 'italic', 'underline', 'customClear', 'fontSize', 'textColor', 'backgroundColor','strikeThrough', 'subscript', 'superscript','inlineClass'],
        align: 'left',
        buttonsVisible: 7
      },
      moreParagraph: {
        buttons: ['alignLeft', 'alignCenter', 'alignRight', 'formatOL', 'formatUL', 'lineHeight', 'alignJustify', 'paragraphFormat', 'paragraphStyle', 'outdent', 'indent', 'quote'],
        align: 'left',
        buttonsVisible: 6
      },
      moreRich: {
        buttons: ['insertLink', 'insertImage', 'insertVideo', 'insertTable', 'emoticons', 'fontAwesome', 'specialCharacters', 'embedly', 'insertFile', 'insertHR'],
        align: 'left',
        buttonsVisible: 5
      },
      moreMisc: {
        buttons: ['undo', 'redo', 'html', 'fullscreen', 'print', 'spellChecker', 'selectAll', 'help'],
        align: 'right',
        buttonsVisible: 3
      }
    },
    lineHeights: {
      Default: '',
      Single: '1',
      '1.15': '1.15',
      '1.5': '1.5',
      Double: '2'
    },
    imageUploadParams: {
      token: 'AuthToken token=' + Authorization.getAuthToken().authtoken
    },
    imageInsertButtons: ['imageBack', '|', 'imageUpload', 'imageByURL'],
    imageMaxSize: 1024 * 1024 * 50,
    imageStyles: {
      'fr-rounded':'Rounded',
      'fr-bordered': 'Bordered',
      'fr-shadow':'Shadow',
      'fr-centered':'Centered'
    },
    fileUploadURL: 'files/editor-file',
    fileUploadParams: {
      token: 'AuthToken token=' + Authorization.getAuthToken().authtoken
    },
    fileMaxSize: 1024 * 1024 * 500,
    videoUploadURL: 'files/editor-video',
    videoUploadParams: {
      token: 'AuthToken token=' + Authorization.getAuthToken().authtoken
    },
    videoMaxSize: 1024 * 1024 * 500,
    linkEditButtons: ['linkOpen', 'linkStyle', 'linkEdit', 'linkRemove'],
    inlineClasses: {
      'fr-class-code': 'Code',
      'fr-class-dark': 'Code Dark',
      'fr-class-highlighted': 'Highlighted',
      'fr-class-transparency': 'Transparent'
    },
    events: {
      'paste.afterCleanup': function (clipboard_html) {
        var replaceWidths = function(stg){
          var div = document.createElement('div');
          div.innerHTML = stg;
          var targets = div.querySelectorAll('table[width]');
          if (targets.length){
            for (var i = 0; i < targets.length; i++){
              targets[i].width = 'auto';
            }
          };
          var newString = div.innerHTML;
          return newString;
        };
        return replaceWidths(clipboard_html); // replaces tablet widths via the string-to-elm-to-string method
      },
      'commands.after': function (cmd, param1, param2) {
        if(param2 && param2 === 'html') {
          document.querySelector('.fr-code').setAttribute('data-gramm', 'false');
        }
      }
    }
  };
  self.froalaOptions = Object.assign({}, self.froalaLocalOptions, FroalaOptions);

  var locationChange = $scope.$on('$locationChangeStart', function(event) {
    if (self.editSaved) {
      // Allow the route change to progress
      self.denied = true;
      Application.messaging.clearMessages('trackstate');
      return;
    }

    // Halt the route change and question the action
    self.navigationPath = {};
    self.navigationPath.targetPath = Application.navigation.getPath();
    self.navigationPath.targetSearch = Application.navigation.getUrlParameters();
    self.navigationPath.targetHash = Application.navigation.getHash();

    event.preventDefault();
    self.showDeparture = true;
    self.onLocationChange = function() {
      locationChange();
      Application.messaging.clearMessages('trackstate');
    };
  });

  var trackState = self.trackState = Application.trackState.get();
  if (trackState && trackState.ttl < new Date().valueOf()) {
    trackState = self.trackState = false;
  }

  if (trackState) {
    var tsText = self.newArticle ? 'edit.article.add_track' : 'edit.article.edit_track';
    $translate(tsText, {title: trackState.trackTitle})
    .then(function(result) {
      Application.messaging.addMessage({type: 'insidetrack', text: result, trackstate: true, link: '/edit/tracks/' + trackState.track});
    });
  }

  var article = {};
  article.type = 'article';
  article.tags = [];
  article.linked_category = [];
  article.privacy_collaborators = [];
  article.allow_comments = false;
  article.explore_hide = trackState ? true : false;
  self.showCollaborators = false;
  self.activeTab = 'details';
  self.returnToAfterPreview = 'settings';

  self.navigationDirectory = {
    'details': {
      next: 'images',
      previous: null,
      required: ['title', 'author', 'content']
    },
    'images': {
      next: trackState ? 'settings' : 'categories',
      previous: 'details',
      required: null
    },
    'categories': {
      next: 'settings',
      previous: 'images',
      required: null
    },
    'settings': {
      next: 'preview',
      previous: trackState ? 'images' : 'categories',
      required: null
    },
    'preview': {
      next: null,
      previous: 'settings',
      required: null
    },
    requiredKeyMap: {
      title: 'global.forms.labels_title',
      author: 'global.forms.labels_author',
      content: 'global.contentTypes.generic'
    }
  };

  self.nextSection = function(item) {
    var nextClicked = item ? false : true;
    var item = item ? self.navigationDirectory[item].previous : self.activeTab;
    var next = self.navigationDirectory[item].next;
    var missing = '';
    var allow = true;

    var findIssues = function(check) {
      var current = self.navigationDirectory[check];
      if (current.required) {
        for (var i = 0; i < current.required.length; i++) {
          if (!self.article[current.required[i]]) {
            var addition = self.navigationDirectory.requiredKeyMap[current.required[i]] ? self.translations[self.navigationDirectory.requiredKeyMap[current.required[i]]] : current.required[i];
            allow = false;
            missing = missing + ' ' + addition + ',';
          }
        }
      }
      if (current.previous) {
        findIssues(current.previous);
      }
    };

    findIssues(item);

    if (allow && next) {
      if (next === 'preview') {
        self.returnToAfterPreview = self.activeTab;
      }
      if (!self.article._id && self.autoDuration) {
        self.article.duration = self.readingTime();
      }
      if (self.newArticle || !nextClicked) {
        self.activeTab = next;
        Application.scrollTop();
        return;
      }
      self.saveProgress('next')
      .then(function() {
        self.activeTab = next;
        Application.scrollTop();
      });
    }

    if (missing) {
      Application.messaging.addMessage({type: 'error', text: self.translations['edit.general.notification_fieldsMissing'] + missing.slice(0, -1) + '.', duration: 5});
    }
  };

  self.readingTime = function() {
    if (!angular.isString(self.article.content)) {
      return '';
    }
    var words = self.article.content.trim().split(/\s+/g).length;
    var wordsPerSecond = 270 / 60;
    return Math.round(words / wordsPerSecond);
  };

  self.saveProgress = function(next) {
    if (!self.article._id) {
      return;
    }

    self.updateIndicator = true;
    self.article.summary = self.article.content;
    if(self.is_collaborator) {
      self.article.approval_required = true;
      self.article.approved = false;
    }
    return Articles.update({
      subresource: self.article._id,
      fields: 'title,description,author,content,summary,duration,tags,image,banner_image,user,linked_category,explore_hide,approval_required,approved,last_approved_by,last_approved_by,privacy_collaborators,privacy_locations,privacy_departments,privacy_teams,privacy_org_levels,privacy_grades,private,cover_justification,featured_justification,rating_configuration,allow_comments'
    }, self.article).$promise.then(function(article) {
      Analyze.record({resource: 'modifications'}, {document: article._id, type: 'article'});
      Application.analyticsProvider.trackEvent('article_updated', {content: article._id, content_type: 'article', title: article.title});
      self.updateIndicator = false;
      Application.messaging.addMessage({type: 'success', text: self.translations['modules.notifications.article_savedPt1'] + ' '  + $filter('limitTo')(self.article.title, 25) + (self.article.title.length > 25 ? '[...]' : '')  + ' ' + self.translations['modules.notifications.article_savedPt2'], duration: 5});
      self.editSaved = true;
      if (trackState && !next) {
        Application.navigation.goTo('/edit/tracks/' + trackState.track);
      }
    }).catch(function(err) {
      console.log('Error in update: ', err);
      self.updateIndicator = false
      if (err.data && err.data.status === 401 && err.data.message) {
        Application.messaging.addMessage({type: 'error', duration: 7, text: err.data.message});
        return;
      }
      Application.messaging.addMessage({type: 'error', text: self.translations['modules.notifications.content_issue_updating'], duration: 5});
    });
  };

  self.createArticle = function() {
    if (!self.newArticle || self.article._id) {
      return;
    }

    self.updateIndicator = true;
    self.article.user = self.user._id;
    self.article.summary = self.article.content;
    if(self.is_collaborator) {
      self.article.approval_required = true;
      self.article.approved = false;
    }
    Articles.create(self.article).$promise
    .then(function(article) {
      Analyze.record({resource: 'creations'}, {document: article._id, type: 'article'});
      Application.analyticsProvider.trackEvent('article_created', {content: article._id, content_type: 'article', title: article.title});
      self.updateIndicator = false;
      Application.messaging.addMessage({type: 'success', text: self.translations['modules.notifications.article_createdPt1'] + ' ' + self.article.title + ' ' + self.translations['modules.notifications.article_createdPt2'], duration: 5});
      if (trackState) {
        trackState.contentId = article._id;
        trackState.contentTitle = article.title;
        Application.trackState.set(trackState);
        self.editSaved = true;
        Application.navigation.goTo('/edit/tracks/' + trackState.track);
        return;
      }
      self.editSaved = true;
      Application.navigation.goTo('/view/articles/' + article._id);
    }).catch(function(err) {
      self.updateIndicator = false
      if (err.data && err.data.status === 401 && err.data.message) {
        Application.messaging.addMessage({type: 'error', duration: 7, text: err.data.message});
      }
      console.log('Error in update: ', err);
    });
  };

  self.removeArticle = function() {
    self.archiveInfo = {};
    self.updateIndicator = true;
    Viewables.archive({content: [{id: self.article._id, type: 'article'}]}).$promise
    .then(function(results) {
      self.archiveInfo.results = results;
      self.archiveInfo.show = results.in_track?.length || results.in_workflow?.length || results.in_journey?.length;
      self.updateIndicator = false;
      self.showDelete = false;
      if (self.archiveInfo.show) {
        return;
      }
      Application.messaging.addMessage({type: 'success', text: self.translations['modules.notifications.article_removed'], duration: 5});
      self.editSaved = true;
      Analyze.record({resource: 'deletions'}, {document: self.article._id, type: 'article'});
      Application.analyticsProvider.trackEvent('article_deleted', {content: article._id, content_type: 'article', title: article.title});
      Application.navigation.goTo('/overview/content');
    }).catch(function(err) {
      self.editSaved = true;
      self.updateIndicator = false;
      self.showDelete = false;
      Application.messaging.addMessage({type: 'error', text: self.translations['modules.notifications.content_issue_removing'], duration: 5});
    });
  };

  self.goBack = function() {
    if (!self.denied || !self.backLocation) {
      Application.navigation.back();
      self.denied = true;
      return;
    }
    self.denied = true;
    var location = self.backLocation.split('/#/');
    if (location.length !== 2) {
      Application.navigation.back();
      return;
    }
    Application.navigation.goTo(location[1]);
  };

  self.specialClose = function() {
    self.activeTab = self.returnToAfterPreview;
  };

  self.surveyAssociation = {
    surveysData: [],
    surveyIds: [],
    omittedContentTypes: SurveyHelper.chipSearchOmittedContentTypes,
    initialIdsByType: {survey: []},
    initSurveyData: function() {
      self.surveyAssociation.initialIdsByType.survey = self.article.surveys;
      self.surveyAssociation.surveyIds.push(self.article.surveys[0].survey_id);
    }
  };

  self.partners = {
    partnerPermission: 'tenant',
    changePermission: (permission) => {
      self.partners.partnerPermission = permission;
    }
  }

  self.initialize = function () {
    if (!Authorization.hasValidAuthToken()) {
      if (Application.navigation.isRouteSecure()){
        Application.navigation.goToSignIn();
      }
    }

    if (self.newArticle) {
      self.article = article;
      if(self.is_collaborator) {
        self.article.privacy_collaborators.push(self.user._id);
      }
      self.startEditWatch();
      return;
    }

    AdminContent.get({
      subresource: routeParameters.id,
      fields: 'title,company,description,author,content,summary,duration,tags,image,banner_image,user,linked_category,explore_hide,approval_required,approved,last_approved_by,last_approved_by,privacy_collaborators,privacy_locations,privacy_departments,privacy_teams,privacy_org_levels,privacy_grades,private,cover_justification,featured_justification,rating_configuration,allow_comments,surveys,partner_permissions',
      types: 'articles'
    }, async function (data) {
      if (!data || (data.company !== self.authtoken.company._id) || (self.is_collaborator && data.privacy_collaborators.length && data.privacy_collaborators.indexOf(self.user._id) === -1)) {
        Application.messaging.addMessage({type: 'error', text: self.translations['modules.notifications.articleNotEditable'], duration: 5});
        locationChange();
        Application.navigation.goToHome();
      }

      self.article = data;
      if(!self.article.privacy_collaborators) {
        self.article.privacy_collaborators = [];
      }
      if(self.article.privacy_collaborators.length && !self.is_collaborator) {
        self.showCollaborators = true;
      }
      if (!self.article.image) {
        self.article.image = '';
      }
      if (self.article.surveys.length) {
        self.surveyAssociation.initSurveyData();
      }
      if (self.article.partner_permissions) {
        self.partners.partnerPermission = self.article.partner_permissions;
      }
      self.startEditWatch();
    }, function (error) {
      Application.messaging.addMessage({type: 'error', text: self.translations['modules.notifications.unableToFindArticle'], duration: 5});
    });
  };

  self.startEditWatch = function() {
    $scope.$watch('article.article', function(newVal, oldVal) {
      if (!newVal || newVal === oldVal) {
        return;
      }
      self.editSaved = false;
    }, true);

    $scope.$watch('article.surveyAssociation.surveysData', function(newVal, oldVal) {
      if (!newVal || newVal === oldVal) {
        return;
      }
      self.surveyAssociation.surveyIds = newVal.map(survey => survey._id);
    }, true);

    $scope.$watch('article.surveyAssociation.surveyIds', function(newVal, oldVal) {
      if (!newVal || newVal === oldVal) {
        return;
      }
      self.article.surveys = newVal.map(surveyId => ({survey_id: surveyId}));
    }, true);

    $scope.$watch('article.partners.partnerPermission', function(newVal, oldVal) {
      if (!newVal || newVal === oldVal) {
        return;
      }
      self.article.partner_permissions = newVal;
    }, true);
  };

  $translate([
    'edit.general.notification_fieldsMissing',
    'edit.general.notification_titleMissing',
    'edit.general.notification_confirmLeave',
    'modules.notifications.article_createdPt1',
    'modules.notifications.article_createdPt2',
    'modules.notifications.article_savedPt1',
    'modules.notifications.article_savedPt2',
    'modules.notifications.article_removed',
    'modules.notifications.unableToFindArticle',
    'modules.notifications.articleNotEditable',
    'global.forms.labels_title',
    'global.forms.labels_author',
    'global.contentTypes.generic',
    'modules.notifications.content_issue_updating',
    'modules.notifications.content_issue_removing'
    ]).then(function(translations){
    self.translations = translations;
    self.initialize();
  });
}]);
